

























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mixin as clickaway } from 'vue-clickaway';
import { ConditionViewModel } from './models/conditionViewModel';
import { IConditionsManager } from './models/conditionsManager';
import ConditionConfigurator from './ConditionConfigurator.vue';
import Icon from '../../icons/Icon.vue';

@Component({
	mixins: [
		clickaway
	],
	components: {
		ConditionConfigurator,
		Icon
	}
})
export default class ConditionButton extends Vue {
	@Prop() public value: ConditionViewModel;
	@Prop() public manager: IConditionsManager;
	@Prop({default: false}) public disabled: boolean;

	public condition: ConditionViewModel | undefined = undefined;
	public isOpen = false;
	public deleted = false;
	public allowClickAway = true;

	@Watch('value', { immediate: true })
	public onValueChanged(value: ConditionViewModel, previous: ConditionViewModel) {
		this.condition = value;
		this.isOpen = this.condition.active || false;
		this.checkConditionStillValid();
	}

	public beforeDestroy() {
		if (!this.deleted && this.isOpen) {
			this.closeConfig();
		}
	}

	public getIconComponent(condition: ConditionViewModel) {
		const pickerOption = this.manager.conditions.find(c => c.id === condition.attribute);
		if (pickerOption && pickerOption.icon) {
			return pickerOption.icon;
		} else if (condition.invalid) {
			return 'ErrorIcon';
		}
		return '';
	}

	public onMouseDownInside() {
		this.allowClickAway = false;
	}

	public onMouseUpInside() {
		this.allowClickAway = true;
	}

	public closeConfig() {
		if (this.allowClickAway) {
			this.checkConditionStillValid();
			this.$emit('updated', this.condition);
			this.isOpen = false;
		}

		this.allowClickAway = true;
	}

	public openConfig() {
		if (this.disabled) {
			return;
		}

		this.isOpen = true;
	}

	public updateCondition(condition: ConditionViewModel) {
		this.condition = condition;
	}

	public onConfigCompleted(condition: ConditionViewModel) {
		this.condition = condition;
		this.closeConfig();
	}

	public deleteCondition() {
		if (this.disabled) {
			return;
		}

		this.deleted = true;
		this.$emit('deleted');
	}

	private checkConditionStillValid() {
		if (this.condition) {
			const isInvalid = !this.manager.isConditionValid(this.condition);
			const currentlyInvalid = !!this.condition.invalid;
			if (isInvalid !== currentlyInvalid) {
				this.condition.invalid = isInvalid;
				this.$emit('updated', this.condition);
			}
		}
	}
}
